import React, { useState, useCallback, useContext } from "react";
import axios from "axios";
import ParamContext from "../Context";
import { CircularProgress, Tooltip, IconButton } from "@mui/material";
import { mdiLock, mdiLockOpen } from "@mdi/js";
import Iconn from "@mdi/react";

//The isCheckbox variable takes two values: true if it is a checkbox, and false otherwise.
//In this case, the iconTrue and iconFalse variables are not needed."
const FlagComponent = ({
  isCheckbox,
  srv,
  row,
  att,
  flagatt,//usually att is enough but in some casses the att and flagatt are different
  title,
  titleFalse,
  flagman,
  setFlagman,
  showAlert,
  checkboxFalse,
  checkboxTrue, isIcon,iconTrue,iconFalse
}) => {
  const [loading, setLoading] = useState(false);
  const Gfunc = require("../Gfunc");
  const param = useContext(ParamContext);

  const flagMan = useCallback(
    async (row, att) => {
      setLoading(true);
      //setFlag(row[att])
      var data = { srv: srv, id: row.DT_RowId.substr(1), att: flagatt??att, val: row[att] ? 1 : 0 }
      // console.log(data);
    //   var data = new FormData();
    //   data.append("srv", srv);
    //   data.append("id", row.DT_RowId);
    //   data.append("att", att);
    //   data.append("val", row[att] ? 1 : 0);


      //data = JSON.stringify(data)
      try {
        await axios
          .post(param.urlService + "flagman.php", data, {
            headers: Gfunc.getHeader(),
          })
          .then((response) => {
            if (response.data.err && response.data.err !== "-1") {
              alert(response.data.err);
            } else {
              Gfunc.axiosResponse(response, () => {
                if (response.data.jData) {
                  // Toggle the value
                  const updatedValue = !row[att];
                  // setFlag(updatedValue);
                  setFlagman(!flagman);
                  // Update the row value
                  row[att] = updatedValue;
                } else {
                    alert(response.data.err);
                }
              });
            }
          })
          .catch((error) => alert(error))
      } catch (error) {
        alert(error);
      }
      setLoading(false);
    },
    [srv, showAlert, Gfunc, flagman, param.urlService, setFlagman]
  );

  return !loading ? (
    <Tooltip
      title={titleFalse?row[att]?title:titleFalse:title}
      disableInteractive
    >
      <IconButton sx={{ p: 0 }} onClick={() => flagMan(row, att)}>
        {isCheckbox || isIcon ? (
          row[att] ? (
            checkboxTrue
          ) : (
            checkboxFalse
          )
        ) : row[att] ? (
          iconTrue??<Iconn path={mdiLock} size="18px" color="red" />
        ) : (
          iconFalse??<Iconn path={mdiLockOpen} color="green" size="18px" />
        )}
      </IconButton>
    </Tooltip>
  ) : (
    <CircularProgress size={"20px"} />
  );
};

export default FlagComponent;
